"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CyberiaSystems = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const Units_1 = require("../../Units");
const RoboticWorkforce_1 = require("../base/RoboticWorkforce");
class CyberiaSystems extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.CYBERIA_SYSTEMS,
            cost: 16,
            productionBox: Units_1.Units.of({ steel: 1 }),
            metadata: {
                cardNumber: 'X53',
                description: 'Increase your steel production 1 step. Copy the production boxes of 2 of your other cards with building tags.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.steel(1));
                    b.text('COPY');
                    b.production((pb) => pb.building(1).played);
                    b.production((pb) => pb.building(1).played);
                }),
            },
        });
    }
    canPlay(player) {
        const initialCopyableCards = RoboticWorkforce_1.RoboticWorkforce.getAvailableCards(player);
        if (initialCopyableCards.length === 0)
            return false;
        const productionBoxes = initialCopyableCards.map((c) => c.productionBox);
        const maxProductionGains = Units_1.Units.of({
            megacredits: Math.max(...productionBoxes.map((p) => (p === null || p === void 0 ? void 0 : p.megacredits) || 0)),
            steel: Math.max(...productionBoxes.map((p) => (p === null || p === void 0 ? void 0 : p.steel) || 0)),
            titanium: Math.max(...productionBoxes.map((p) => (p === null || p === void 0 ? void 0 : p.titanium) || 0)),
            plants: Math.max(...productionBoxes.map((p) => (p === null || p === void 0 ? void 0 : p.plants) || 0)),
            energy: Math.max(...productionBoxes.map((p) => (p === null || p === void 0 ? void 0 : p.energy) || 0)),
            heat: Math.max(...productionBoxes.map((p) => (p === null || p === void 0 ? void 0 : p.heat) || 0)),
        });
        return RoboticWorkforce_1.RoboticWorkforce.getAvailableCards(player, maxProductionGains).length > 1;
    }
    play(player) {
        player.addProduction(Resources_1.Resources.STEEL, 1, { log: true });
        let availableCards = RoboticWorkforce_1.RoboticWorkforce.getAvailableCards(player);
        if (availableCards.length === 0)
            return undefined;
        return RoboticWorkforce_1.RoboticWorkforce.selectBuildingCard(player, availableCards, this.name, 'Select first builder card to copy', (card) => {
            const secondSet = RoboticWorkforce_1.RoboticWorkforce.getAvailableCards(player).filter((c) => c.name !== card.name && c.name !== this.name);
            return RoboticWorkforce_1.RoboticWorkforce.selectBuildingCard(player, secondSet, this.name, 'Select second builder card to copy');
        });
    }
}
exports.CyberiaSystems = CyberiaSystems;
//# sourceMappingURL=CyberiaSystems.js.map